import { Flex, Text, SimpleGrid, Icon } from "@chakra-ui/react";
import Select from "react-select";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchSingleCustomer } from "../../../store/slices/customers";
import { transformGuides } from "../../../helpers/transformGuides";
import { FormikProps } from "formik";
import { FormWrapper } from "../../FormWrapper/FormWrapper";
import { BaseInput } from "../../Controls/BaseInput";
import { BaseTextArea } from "../../Controls/BaseTextArea";
import { BaseControl } from "../../Controls/BaseControl";
import { CustomerForm } from "../../../model/customers";
import { ViewInformationBlock } from "@/components/ViewInformationBlock/ViewInformationBlock";
import { FiBriefcase } from "react-icons/fi";
import api from "@/api";

const colourStyles = {
  control: (styles: any) => ({ ...styles, borderColor: "grey.200" }),
};

interface UpdateCustomerBlockProps {
  formik: FormikProps<CustomerForm>
}

export const UpdateCustomerBlock = ({ formik }: UpdateCustomerBlockProps) => {
  const { id } = useParams()
  const { guides } = useAppSelector(
    (state: RootState) => state.guides
  );
  const [bussinessAreaList, setBussinessAreaList] = useState<{ value: string, label: string | undefined }[]>([])
  const [recruitersOptions, setRecruitersOptions] = useState<any[]>([])

  useEffect(() => {
    if (guides) {
      const resultStatusList = transformGuides(guides.BusinessArea)
      setBussinessAreaList(resultStatusList)
    }
  }, [guides])

  useEffect(() => {
    api.recruiters.recruiters({ customer: true }).then((res) => {
      const resultRecruiters = res.data.map((el: any) => ({
        value: el.id,
        label: el.username,
      }))
      setRecruitersOptions(resultRecruiters)
    })
  }, [])

  const dispatch = useAppDispatch();


  useEffect(() => {
    dispatch(fetchSingleCustomer({params: {id: Number(id)}}))
  }, [id, dispatch])

  return (
    <ViewInformationBlock icon={<Icon as={FiBriefcase as any} boxSize={5} color="#3b515e" />} title="Основная информация">
    <Flex flexDirection="column" gap="24px">
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        <BaseInput
          fieldTitle="Название заказчика"
          requiredField={true}
          value={formik.values.name}
          onChange={formik.handleChange}
          name="name"
          placeholder="Введите название заказчика"
        />
        <BaseInput
          fieldTitle="ИНН"
          requiredField={true}
          value={(formik.values as any).inn}
          onChange={(e) => {
            const onlyDigits = e.target.value.replace(/\D/g, "");
            const trimmed = onlyDigits.slice(0, 12);
            formik.setFieldValue("inn", trimmed);
          }}
          name="inn"
          inputMode="numeric"
          pattern="[0-9]*"
          isInvalid={Boolean((formik.values as any).inn) && (((formik.values as any).inn.length < 10) || ((formik.values as any).inn.length > 12))}
          placeholder="Введите ИНН"
        />
      </SimpleGrid>
      <BaseTextArea
        fieldTitle="Описание заказчика"
        value={(formik.values as any).description}
        onChange={formik.handleChange}
        name="description"
        placeholder="Краткое описание деятельности компании..."
      />
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        <BaseControl fieldTitle="Сфера деятельности" requiredField>
          <Select
            menuPosition="fixed"
            className="basic-single"
            classNamePrefix="select"
            isSearchable={true}
            name="business_area_id"
            options={bussinessAreaList}
            styles={colourStyles}
            placeholder="Выберите сферу деятельности"
            value={
              bussinessAreaList.find(o => String(o.value) === String(formik.values.business_area_id)) || null
            }
            onChange={(arg) => {
              formik.setFieldValue("business_area_id", arg?.value)
            }}
          />
        </BaseControl>
        <BaseControl fieldTitle="Ответственный аккаунт-менеджер" requiredField>
          <Select
            menuPosition="fixed"
            className="basic-single"
            classNamePrefix="select"
            isSearchable={true}
            name="responsible_user_id"
            styles={colourStyles}
            placeholder="Выберите менеджера"
            value={
              recruitersOptions.find(o => o.value === formik.values.responsible_user_id) || null
            }
            options={recruitersOptions}
            onChange={(arg) => {
              formik.setFieldValue("responsible_user_id", arg?.value)
            }}
          />
        </BaseControl>
      </SimpleGrid>
      <BaseTextArea
        fieldTitle="Комментарий"
        value={formik.values.comments}
        onChange={formik.handleChange}
        name="comments"
        placeholder="Дополнительная информация о заказчике..."
      />
    </Flex>
    </ViewInformationBlock>
  );
};
